import { request } from "../api/client";
import type { AcademicGraph, AcademicKind, AcademicPage } from "./types";
export function academicList(kind: AcademicKind, search: string, cursor: string, active: boolean, signal?: AbortSignal) {
  const query = new URLSearchParams({ kind });
  if (search.trim()) query.set("search", search.trim());
  if (cursor) query.set("cursor", cursor);
  if (active) query.set("active", "true");
  return request<AcademicPage>(`/risha/records?${query}`, "GET", undefined, signal);
}
export function academicRead(id: string, signal?: AbortSignal) {
  return request<AcademicGraph>(`/risha/record?${new URLSearchParams({ id })}`, "GET", undefined, signal);
}
